import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { FETCH_DOCUMENT } from "@/queries/FetchDocument";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { CircularProgress } from "@mui/material";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { downloadUrl } from "@sequentech/ui-core";
import { GET_DOCUMENT } from "@/queries/GetDocument";
import { ReportPasswordDialog } from "../Reports/ReportPasswordDialog";
export var DownloadDocument = function (_a) {
    var _b, _c;
    var onDownload = _a.onDownload, fileName = _a.fileName, documentId = _a.documentId, electionEventId = _a.electionEventId, withProgress = _a.withProgress, onSuccess = _a.onSuccess, _d = _a.showReportPasswordDialog, showReportPasswordDialog = _d === void 0 ? false : _d;
    var _e = React.useState(false), downloaded = _e[0], setDownloaded = _e[1];
    var _f = React.useState(), passwordDocument = _f[0], setPasswordDocument = _f[1];
    var downloadStarted = useRef(false);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var documentScope = JSON.stringify([tenantId, documentId]);
    var _g = useQuery(GET_DOCUMENT, {
        variables: {
            id: documentId,
            tenantId: tenantId,
        },
        skip: !documentId || !tenantId || downloaded,
        pollInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
        onError: function (error) {
            console.log("error downloading doc: ".concat(error.message));
        },
        onCompleted: function (data) {
            var _a;
            console.log("success downloading doc");
            var document = (_a = data === null || data === void 0 ? void 0 : data.sequent_backend_document) === null || _a === void 0 ? void 0 : _a[0];
            if (document) {
                // Document found, stop polling and trigger the next query
                console.log("Document found, stopping polling.");
                stopPolling();
                harvestRefetch();
            }
        },
    }), documents = _g.data, stopPolling = _g.stopPolling;
    var _h = useQuery(FETCH_DOCUMENT, {
        variables: {
            electionEventId: electionEventId,
            documentId: documentId,
        },
        skip: !documentId || !tenantId || downloaded,
        pollInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
        onCompleted: function () {
            console.log("completed fetching document");
            //harvestRefetch()
        },
    }), loading = _h.loading, error = _h.error, data = _h.data, harvestRefetch = _h.refetch;
    var document = (_b = documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document) === null || _b === void 0 ? void 0 : _b[0];
    useEffect(function () {
        var _a;
        if (!error &&
            ((_a = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _a === void 0 ? void 0 : _a.url) &&
            !downloaded &&
            !downloadStarted.current &&
            (!showReportPasswordDialog || document) &&
            (fileName || document)) {
            downloadStarted.current = true;
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            console.log("setting downloaded true");
            // Keep the real extension (.epdf for encrypted reports), needed for decryption.
            var name_1 = showReportPasswordDialog
                ? (document === null || document === void 0 ? void 0 : document.name) || fileName || "file"
                : fileName || (document === null || document === void 0 ? void 0 : document.name) || "file";
            console.log("calling downloadUrl");
            downloadUrl(data.fetchDocument.url, name_1)
                .then(function () {
                var _a, _b, _c;
                if (showReportPasswordDialog &&
                    (((_b = (_a = document === null || document === void 0 ? void 0 : document.annotations) === null || _a === void 0 ? void 0 : _a.access) === null || _b === void 0 ? void 0 : _b.password_secret_id) ||
                        name_1.endsWith(".epdf"))) {
                    // Apollo clears metadata when the completed download skips its query.
                    setPasswordDocument({
                        scope: documentScope,
                        access: (_c = document === null || document === void 0 ? void 0 : document.annotations) === null || _c === void 0 ? void 0 : _c.access,
                    });
                }
                else {
                    onDownload();
                }
            })
                .finally(function () {
                setDownloaded(true);
            });
        }
    }, [
        data,
        (_c = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _c === void 0 ? void 0 : _c.url,
        error,
        loading,
        document,
        documentScope,
        fileName,
        downloaded,
        showReportPasswordDialog,
        setDownloaded,
        onDownload,
        downloadUrl,
    ]);
    return (passwordDocument === null || passwordDocument === void 0 ? void 0 : passwordDocument.scope) === documentScope ? (_jsx(ReportPasswordDialog, { documentId: documentId, access: passwordDocument.access, onClose: function () {
            setPasswordDocument(undefined);
            onDownload();
        } }, "".concat(tenantId, ":").concat(documentId))) : withProgress && !downloaded ? (_jsx(CircularProgress, {})) : (_jsx(_Fragment, {}));
};
